import React from 'react';
import { DateRange } from "../../../common/dateRange/dateRange";

const AllTimeHeader = () => {
  return (
    <div>
      <h2 className="stress">All Time</h2>
    </div>
  );
};

export default AllTimeHeader;



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/allTimeHeader.js